import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'features/rootReducer';
import { GetConnectMemberListParams, GetConnectMembersResponse } from 'types/member';

export interface ConnectMemberListState {
  list: {
    loading: boolean;
    data: GetConnectMembersResponse;
    error: any;
  };
}

const initialState: ConnectMemberListState = {
  list: {
    loading: false,
    data: {
      currentPage: 0,
      items: [],
      totalItems: 0,
      totalPages: 0,
    },
    error: null,
  },
};

export const connectMemberListSlice = createSlice({
  name: 'connectMemberList',
  initialState,
  reducers: {
    getConnectMemberList: (
      state: ConnectMemberListState,
      _action: PayloadAction<GetConnectMemberListParams>,
    ) => {
      state.list.loading = true;
    },
    getConnectMemberListSuccess: (
      state: ConnectMemberListState,
      action: PayloadAction<GetConnectMembersResponse>,
    ) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },
    getConnectMemberListFailure: (state: ConnectMemberListState, action: PayloadAction<any>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },
  },
});

export const connectMemberListReducer = connectMemberListSlice.reducer;
export const connectMemberListActions = connectMemberListSlice.actions;

export const selectConnectMemberList = (state: RootState) =>
  state.member.connectMemberList.list.data;
export const selectConnectMemberListLoading = (state: RootState) =>
  state.member.connectMemberList.list.loading;
